import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'reportNumber',
})
export class ReportNumberPipe implements PipeTransform {
  transform(value: number, digits = 1): string {
    const factor = 100;
    const result = Math.round(value * factor) / factor;
    return value === null || value === -1 || isNaN(result) ? '-' : result.toLocaleString('de-DE', { minimumFractionDigits: digits, maximumFractionDigits: digits });
  }
}
